import api from './api'

export const searchCategory = async (query, token, type) => {
  return await api.get(`${process.env.VUE_APP_SHARED_API}api/${type}?search=${query}`)
}
